import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useContent } from "@/context/SiteContentContext";

const DEFAULT_ABOUT = `Le Salon is a quiet gathering place for women who love living beautifully — slowly, intentionally, and in the French style.

Here we share letters, lives, kitchen mornings, small pleasures, and the occasional live broadcast. It is a magazine, a journal, and a community — all in one hushed doorway.

Founded by Mimi as a companion to Belle Inspiration Magazine and Joie de Vivre TV.`;

const About = () => {
  const body = useContent("about.body", DEFAULT_ABOUT);
  const heroImage = useContent("about.hero.image", "");
  return (
    <div className="app-shell" data-testid="about-page">
      <Navbar />
      <main style={{ paddingTop: 120, paddingBottom: 80 }}>
        <div className="container-belle" style={{ maxWidth: 720 }}>
          <div className="overline" style={{ color: "var(--brand-accent)" }}>Le Salon</div>
          <h1
            className="editorial-h1"
            style={{ fontSize: "clamp(40px, 5.5vw, 64px)", marginTop: 12, marginBottom: 28 }}
          >
            About
          </h1>
          {heroImage && (
            <div
              data-testid="about-hero-image"
              style={{
                marginBottom: 32,
                overflow: "hidden",
                aspectRatio: "16 / 10",
                background: "var(--bg-alt)",
              }}
            >
              <img
                src={heroImage}
                alt=""
                loading="lazy"
                decoding="async"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            </div>
          )}
          <div
            data-testid="about-body"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 18,
              lineHeight: 1.7,
              color: "var(--text-primary)",
              whiteSpace: "pre-wrap",
            }}
          >
            {body}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About;
